import { Tooltip, Typography } from "@mui/material";
import { FC } from "react";
import { thumbnailService } from "../../../Core/Api/services";
import { ThumbnailSize } from "../../../Core/Api/Thumbnail/thumbnail-api-service";

export type TableCellSingleCoverProps = {
  coverId: number;
  titleName?: string;
};

const TableCellSingleCover: FC<TableCellSingleCoverProps> = (props) => {
  const { coverId, titleName } = props;
  return (
    <Tooltip arrow title={<Typography fontWeight={500}>{titleName ? titleName : "#" + coverId}</Typography>}>
      <img
        src={thumbnailService.GetObjectPosterUrl(coverId, ThumbnailSize.small)}
        alt={"Poster " + coverId}
        width={30}
        height={40}
        loading="lazy"
        key={coverId}
        style={{ borderRadius: "3px", margin: 2 }}
      />
    </Tooltip>
  );
};

export default TableCellSingleCover;
